export const AddLogTranslationsDictionary = {
    AddLog: "Add log",
    NoVehicle: "No vehicle",
    LogAdded: "Log Added",
    ViewLog: "View log",

    // Default page text
    Status: "Status",
    Date: "Date",
    Vehicle: "Vehicle",
    NameVinOrSerialNumber: "Name, VIN, or serial number",
    Annotation: "Annotation",
    AddAnnotationPlaceholder: "Add an annotation...",
    EnterOdometer: "Enter odometer",

    // Add button
    Add: "Add",
    SavingInProgress: "Saving in progress",

    // Workflow change status section
    YouHaveBeenSince: "You have been {0} since {1}.",
    Driving: "Driving",
    OnDuty: "On Duty",
    InYardMove: "in Yard Move",

    // Errors
    ValidOdometerError: "You must enter a valid odometer number.",
    NewLogsBeforePreviousError: "New logs cannot be added before your previous log.",
    LogAlreadyExistsError: "A log already exists for the selected date.",
    StatusAndDateAlreadySelectedError: "This Status and Date are already selected.",
    DurationInvalidFutureError: "The selected Duration is invalid because it creates a log set in the future.",

    // Validator errors (key matches value)
    "An HOS log without a vehicle can only be in ON or OFF status.": "An HOS log without a vehicle can only be in ON or OFF status.",
    "Add an annotation to this log.": "Add an annotation to this log.",
    "Annotation must be at least 4 characters long.": "Annotation must be at least 4 characters long.",
    "Annotation cannot be longer than 60 characters.": "Annotation cannot be longer than 60 characters.",
    "Set a date and time for this log.": "Set a date and time for this log.",
    "You've selected date in future, please select correct one": "You've selected date in future, please select correct one",
    "You cannot make changes that will affect the date or duration of driving time.": "You cannot make changes that will affect the date or duration of driving time.",
    "You cannot change an existing situational driving status.": "You cannot change an existing situational driving status.",
    "This change is not allowed because it will affect the date or duration of driving time.": "This change is not allowed because it will affect the date or duration of driving time."
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in AddLogTranslationsDictionary) {
        r.push(AddLogTranslationsDictionary[prop]);
    }
    return r;
};

export const AddLogTranslations = getTranslations();